import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VERIFICATION_STATE } from '../constants';
import ImportLoading from '../import_loading/import_loading';
import Verification from '../import_loading/verification';
import { getImportRequest } from '../store/selectors';
import { setVerificationLabels, setVerificationState } from '../store/actions/verification';

const successMessages = {
  header: 'Your data has been',
  headerHighlight: 'imported!',
  progressing: 'Import complete.'
};

export function Run({
  importRequest,
  setVerificationLabels,
  setVerificationState
}) {
  useEffect(() => {
    setVerificationState(VERIFICATION_STATE.IN_PROGRESS);
    setVerificationLabels({
      footer: 'You will be notified by email when import is complete.',
      progressing: 'Running import...'
    });
  }, []);

  return (
    <div className="container new-import-verfication">
      <ImportLoading importStatus={['complete']} successMessages={successMessages} />
      <Verification redirect={`/${importRequest.id}/review`} />
    </div>
  );
}

Run.propTypes = {
  importRequest: PropTypes.object.isRequired,
  setVerificationLabels: PropTypes.func.isRequired,
  setVerificationState: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state)
});

const mapDispatchToProps = {
  setVerificationLabels,
  setVerificationState
};

export default connect(mapStateToProps, mapDispatchToProps)(Run);
